import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=853a602c&scoped=true&"
import script from "./CloseBtn.vue?vue&type=script&lang=js&"
export * from "./CloseBtn.vue?vue&type=script&lang=js&"
import style0 from "./CloseBtn.vue?vue&type=style&index=0&id=853a602c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853a602c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
